import { render, staticRenderFns } from "./SliceStockists.vue?vue&type=template&id=bd76820c&lang=pug&"
import script from "./SliceStockists.vue?vue&type=script&lang=js&"
export * from "./SliceStockists.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports